// The OAuth2 grant calls. These bypass the shared axios client on purpose:
// they are form-encoded, must never carry a Bearer header, and must never
// trigger refresh-on-401 -- a failed login is not an expired session.

import axios from "axios";
import type { AuthToken } from "./session";

/**
 * Identifies the admin client to the auth service. Public by construction --
 * it ships inside the browser bundle, and the real secret is the password.
 */
const CLIENT_ID = "aob-admin-client";

const FORM_HEADERS = {
  "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
};

export const LOGIN_URL = "/api/v2/auth/oauth/login/";
export const REFRESH_URL = "/api/v2/auth/oauth/refresh/";

export async function login(
  username: string,
  password: string,
  captcha?: string,
): Promise<AuthToken> {
  const params = new URLSearchParams();
  params.append("username", username);
  params.append("password", password);
  params.append("client_id", CLIENT_ID);
  if (captcha) params.append("captcha", captcha);

  const { data } = await axios.post<AuthToken>(LOGIN_URL, params.toString(), {
    headers: FORM_HEADERS,
  });
  return data;
}

export async function refresh(refreshToken: string): Promise<AuthToken> {
  const params = new URLSearchParams();
  params.append("refresh_token", refreshToken);
  params.append("client_id", CLIENT_ID);

  const { data } = await axios.post<AuthToken>(REFRESH_URL, params.toString(), {
    headers: FORM_HEADERS,
  });
  return data;
}
